<div class="row" *ngIf="data?.ivtDistribution?.byMonth?.length > 0">
  <div class="col-xl-4 leftOverview" [ngClass]="{ 'col-lg-12': isFreemium }">
    <ul class="list-group mx-auto">
      <li class="list-group-item">
        <h5>IVT%</h5>
        <ng-container *ngIf="!isFreemium">
          <h5 class="value">{{data?.ivtDistribution?.givtSivtRate | perc:'1.2-2'}}</h5>
        </ng-container>
        <ng-container *ngIf="isFreemium">
          <h5 class="value">??</h5>
        </ng-container>
      </li>
      <li class="list-group-item">
        <h5>
          <span class="colorBox givt"></span>
          GIVT% <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" enTooltip
            title="General Invalid Traffic - Deterministically judged to be non-human traffic; high to very high risk"
            style="cursor: pointer;"></i>
        </h5>
        <ng-container *ngIf="!isFreemium">
          <h5 class="value">{{data?.ivtDistribution?.givtRate | perc:'1.2-2'}}</h5>
        </ng-container>
        <ng-container *ngIf="isFreemium">
          <h5 class="value">??</h5>
        </ng-container>
      </li>
      <li class="list-group-item">
        <h5>
          <span class="colorBox sivt"></span>
          SIVT% <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" enTooltip
            title="Sophisticated Invalid Traffic - Probabilistically judged to be non-human traffic; moderate to high risk traffic"
            style="cursor: pointer;"></i>
        </h5>
        <h5 class="value">
          <ng-container *ngIf="!isFreemium">
            {{data?.ivtDistribution?.sivtRate | perc:'1.2-2'}}
          </ng-container>
          <ng-container *ngIf="isFreemium">
            <h5 class="value">??</h5>
          </ng-container>
        </h5>
      </li>
    </ul>
  </div>
  <div class="col-xl-8 chartContainer" *ngIf="!isFreemium">
    <app-bar-chart [data]="barChartData" [categoryField]="'month'" [valueFields]="['givtRate', 'sivtRate']"
      [type]="'double'" [titleArray]="['GIVT', 'SIVT']"></app-bar-chart>
  </div>
</div>
